import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-77d793bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "user" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dec" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, [
  /*#__PURE__*/_createTextVNode(" -- Alexander Wang "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" from "),
    /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "COMPANYNAME")
  ])
], -1))

import { defineComponent, reactive, watchEffect } from 'vue'
import { useData } from "@/utils/store"


export default /*#__PURE__*/_defineComponent({
  __name: 'Users',
  setup(__props) {

const pageData=useData()

const dec = reactive({
  title: JSON.parse(localStorage.getItem("PAGE_MODEL_2") || JSON.stringify(''))?.title?.join(" "),
  url: JSON.parse(localStorage.getItem("PAGE_MODEL_2") || JSON.stringify(''))?.url,
})
watchEffect(() => {
  const {PAGE_MODEL_2}=pageData.globalData.value
  if(PAGE_MODEL_2){
    dec.title=PAGE_MODEL_2.title.join(' ')
    dec.url=PAGE_MODEL_2.url
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: dec.url,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(dec.title), 1),
      _hoisted_7
    ])
  ]))
}
}

})